import {Group, PassRule} from '../../object'
import {time} from '../../ladmin/utils'

const state = {}
const getters = {}
const mutations = {}

const actions = {
  // Fixme 需要一个精确搜索code的request param
  async getItems ({dispatch}, {pagination, filterItems, search = {}, url = '', precious = false}) {
    let code = (filterItems===undefined)?'':filterItems[0].value
    let name = search.name && search.name.keyword
    let data = await dispatch('getDataFromApi', {
      method: 'get',
      url: url,
      params: {
        page: pagination.page - 1 || 0,
        size: pagination.rowsPerPage || 10,
        searchName: name || '',
        searchCode: code || '',
        precious: precious ? '1' : '0'
      }
    }, {root: true})
    let items = data.content
    let amount = data.totalElements
    return {items, amount}
  },
  async getTeachers ({dispatch}, {pagination, search, filterItems}) {
    return dispatch('getItems', {pagination, search, filterItems, url: ' /authSlot/employee'})
  },
  async getMasters ({dispatch}, {pagination, search, filterItems}) {
    return dispatch('getItems', {pagination, search, filterItems, url: ' /authSlot/graduate'})
  },
  async getBachelors ({dispatch}, {pagination, search, filterItems}) {
    return dispatch('getItems', {pagination, search, filterItems, url: ' /authSlot/undergraduate'})
  },
  async getJStudent ({dispatch}, {pagination, search, filterItems}) {
    return dispatch('getItems', {pagination, search, filterItems, url: ' /authSlot/jjystudent'})
  },
  async getZStudent ({dispatch}, {pagination, search, filterItems}) {
    return dispatch('getItems', {pagination, search, filterItems, url: ' /authSlot/preabroad'})
  },
  async getPartners ({dispatch, rootState}, {pagination, search, filterItems}) {
    let res = await dispatch('getItems', {pagination, search, filterItems, url: '/authSlot/cooperator/'})
    res.items.forEach(item => {
      item.org = new Group({name: item.orgName, id: item.orgCode})
      try {
        item.passRules = JSON.parse(item.ruleJson)
        item.passRules = item.passRules.map(rule => PassRule.fromAPI(rule, rootState.parkingLot.controllerList))
      }
      catch (e) {
        item.passRules = []
      }
    })
    return res
  },

  async setPartners ({dispatch}, partners) {
    let data = partners.map(partner => {
      return {
        code: partner.code,
        name: partner.name,
        orgCode: partner.org ? partner.org.id : '',
        orgName: partner.org ? partner.org.name : '',
        phone: partner.phone,
        fileJson: partner.file,
        contractEndTime: partner.contractEndTime ? time.toTimeStamp(partner.contractEndTime) : '',
        vehicleList: partner.vehicleList,
        ruleJson: JSON.stringify(partner.passRules.map(rule => rule.toAPI()))
      }
    })
    return dispatch('getDataFromApi', {
      method: 'put',
      url: ' /authSlot/cooperator/',
      data: {
        cooperatorDataSycs: data
      }
    }, {root: true})
  },
  async deletePartners ({dispatch}, partners) {
    return dispatch('getDataFromApi', {
      method: 'delete',
      url: ' /authSlot/cooperator/',
      data: {
        ids: partners.map(p => p.code)
      }
    }, {root: true})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
